
import 'isomorphic-fetch';
import { config } from 'config'

export const api = {
	liquidacion: {
		async create(data) {
			const response = await fetch(config.URL_API + '/liquidaciones_proveedores/alta', {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async getAll(id) {
			const response = await fetch(config.URL_API + '/cuentas_proveedores/liquidar/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllDetalle(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async baja(data){
            const response = await fetch(config.URL_API + `/liquidaciones_proveedores/baja`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: JSON.stringify(data)
    	});
            const responseData = await response.json();
            return responseData;
        },
	},
	liquidaciones_fleteros: {
		async imprimir(id) {
			const res = await fetch(config.URL_API + '/liquidaciones_fleteros/pdfLiquidacion/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				}
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/liquidaciones_fleteros/liquidaciones&' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllDetalle(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/liquidaciones_fleteros/liquidacion/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	liquidaciones_proveedor: {
		async imprimir(id) {
			const res = await fetch(config.URL_API + '/liquidaciones_proveedores/pdfLiquidacion/' + id, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				}
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async imprimirCheques(id, codigo_bco) {
			const res = await fetch(`${config.URL_API}/liquidaciones_proveedores/pdfCheques/${id}/${codigo_bco}`, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				}
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/liquidaciones_proveedores/liquidaciones&' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllDetalle(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id) {
			const response = await fetch(config.URL_API + '/liquidaciones_proveedores/liquidacion/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	cuentas: {
		async create(data) {
			const response = await fetch(config.URL_API + '/cobros_clientes/alta', {
				method: 'POST',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
		async imprimir(id, data) {
			const res = await fetch(config.URL_API + '/ventas/' + id + '/imprimir?' + data, {
				method: 'GET',
				headers: {
					'Content-Type': 'application/pdf',
				}
			});
			const buf = await res.arrayBuffer();
			const file = await new File([buf], id + '.pdf', { type: 'application/pdf' })
			return file;
		},
		async getAll(id) {
			const response = await fetch(config.URL_API + '/cuentas_proveedores/liquidar/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAllDetalle(id) {
			const response = await fetch(config.URL_API + '/cobros_clientes/recibo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	alicuotas: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/alicuotas&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	condicionventa: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/condicionventa?' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			});
			const data = await response.json();
			return data;
		},
	},
	puntosdeventas: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/puntosdeventas?' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
			});
			const data = await response.json();
			return data;
		},
	},
	clientes: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/clientes&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	fleteros: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/fleteros&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	proveedores: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/proveedores&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async get(id){
			const response = await fetch(config.URL_API + '/proveedores/id/'+id, {
				method: 'GET',
				headers: {'Content-Type': 'application/x-www-form-urlencoded',},
			});
			const data = await response.json();
			return data;
		},
	},
	fpago: {
		async getAll(query = '') {
			const response = await fetch(config.URL_API + '/formas_pago&' + query, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
	cuentas_bancarias: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/cuentas_bancarias&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
};
